import cancelIcon from "../../../assets/images/cancel.svg";
import checkCircleIcon from "../../../assets/images/check_circle.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const BenefitRow = ({
  benefit,
  plans,
  isMobile = false,
  selectedPlanIndex = 1,
}) => {
  const translate = useLanguageTranslate();

  const renderValue = (value, isMobileView = false) => {
    if (value === "✅") {
      return (
        <img
          src={checkCircleIcon}
          alt="Included"
          className={isMobileView ? "w-5 h-5 inline-block" : "w-5 h-5 mx-auto"}
        />
      );
    }
    if (value === "❌") {
      return (
        <img
          src={cancelIcon}
          alt="Not included"
          className={isMobileView ? "w-5 h-5 inline-block" : "w-5 h-5 mx-auto"}
        />
      );
    }
    // Handle translation objects
    if (typeof value === "object" && value.en && value.ar) {
      return (
        <span className="whitespace-pre-line">
          {translate(value.en, value.ar)}
        </span>
      );
    }
    return <span className="whitespace-pre-line">{value}</span>;
  };

  return (
    <>
      {/* Desktop Row - Show all plans */}
      <tr className="border-b border-[#b7b7b7] last:border-b-0 max767:hidden">
        <td className="py-[24px] px-[20px] text-lg text-[#252C32] whitespace-pre-line font-semibold">
          {translate(benefit.label, benefit.label_ar)}
        </td>
        {benefit.values.map((value, index) => (
          <td
            key={index}
            className="py-[24px] px-[20px] text-center text-[#252C32]"
          >
            {renderValue(value)}
          </td>
        ))}
      </tr>

      {/* Mobile Row - Show only selected plan */}
      <tr className="hidden max767:table-row border-b border-[#DDE2E4] last:border-b-0">
        <td className="py-[24px] pl-[20px] pr-[10px] text-[#252C32] whitespace-pre-line text-sm align-top font-semibold">
          {translate(benefit.label, benefit.label_ar)}
        </td>
        <td className="py-[24px] pl-[20px] pr-[20px] text-right text-[#252C32] text-sm align-top">
          {renderValue(benefit.values[selectedPlanIndex], true)}
        </td>
      </tr>
    </>
  );
};

export default BenefitRow;
